/**
 * SINGLE SOURCE OF TRUTH FOR ALLOWED SUBJECTS
 * 
 * ⚠️ CRITICAL DATABASE LIMITATION:
 * The database has a CHECK constraint: tests_subject_check
 * Currently allows ONLY: 'matematika', 'slovenčina'
 * 
 * TO ADD NEW SUBJECTS (requires 2 steps):
 * 
 * Step 1: Update this frontend constant:
 *   Add entry to SUBJECT_OPTIONS array below
 *   Example: { value: 'angličtina', label: 'Angličtina' }
 * 
 * Step 2: Update database constraint (REQUIRED):
 *   Run SQL migration to modify tests_subject_check constraint
 *   ALTER TABLE tests DROP CONSTRAINT tests_subject_check;
 *   ALTER TABLE tests ADD CONSTRAINT tests_subject_check 
 *     CHECK (subject IN ('matematika', 'slovenčina', 'angličtina', ...));
 *   
 *   OR remove constraint entirely for full flexibility:
 *   ALTER TABLE tests DROP CONSTRAINT tests_subject_check;
 * 
 * WITHOUT Step 2, new subjects will be rejected by database with:
 * "new row violates check constraint tests_subject_check"
 * 
 * Format:
 * - value: lowercase string (must match DB constraint)
 * - label: display name (user-facing, can have capitals/diacritics)
 */

export const SUBJECT_OPTIONS = [
  { value: 'matematika', label: 'Matematika' },
  { value: 'slovenčina', label: 'Slovenčina' },
  { value: 'angličtina', label: 'Angličtina' },
  { value: 'finančná gramotnosť', label: 'Finančná gramotnosť' }
]

/**
 * Get subject label by value
 * @param {string} value - subject value (e.g., 'matematika')
 * @returns {string} - subject label (e.g., 'Matematika')
 */
export const getSubjectLabel = (value) => {
  const subject = SUBJECT_OPTIONS.find(s => s.value === value)
  return subject ? subject.label : value
}

/**
 * Validate if subject value is allowed
 * @param {string} value - subject value to validate
 * @returns {boolean} - true if allowed, false otherwise
 */
export const isValidSubject = (value) => {
  return SUBJECT_OPTIONS.some(s => s.value === value)
}

/**
 * Get default subject value
 * @returns {string} - default subject value
 */
export const getDefaultSubject = () => {
  return SUBJECT_OPTIONS[0]?.value || 'matematika'
}
